import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";

export default class MiejscowosciTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                {
                    Boolean(Boolean(row.dlGps) && Boolean(row.szGps)) ?
                        <TopButtonPointAction buttonIcon={'fa fa-globe'} onClick={() => {
                            this.props.pokazNaMapie(row)
                        }}
                                              titleContent={'Pokaż miejscowość na mapie'}
                                              disabled={this.props.czyJestWyswyetlonaMapa}
                        />
                        :
                        <TopButtonPointAction buttonIcon={'fa fa-search'} onClick={() => {
                            this.props.szukajMiejscowosci(row)
                        }}
                                              titleContent={'Szukaj współrzędnych miejscowości na mapie'}
                                              disabled={this.props.czyJestWyswyetlonaMapa}
                        />
                }
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj miejscowość'} disabled={this.props.czyJestWyswyetlonaMapa}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń miejscowość'} disabled={this.props.czyJestWyswyetlonaMapa}/>
            </div>
        )
    }

    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idMi' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMi' dataSort
                                       thStyle={tabgrid.tg16} tdStyle={tabgrid.tg16}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nazwa miejscowości</TableHeaderColumn>
                    <TableHeaderColumn dataField='szGps' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Szerokość geo.</TableHeaderColumn>
                    <TableHeaderColumn dataField='dlGps' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Długość geo.</TableHeaderColumn>
                    <TableHeaderColumn dataField='idMi'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunPlusDodatkowaHtml('Pokaż','#333333')}</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/miejscowosci/components/MiejscowosciTable.js